export enum EstadoFactura {
    Calculado = 0,
    Emitido = 1,
    Impreso = 2,
    Anulado = 3,
    Error = 4,
    Imputado = 5
}